<template>
    <div>
        <div class="flex flex-col gap-5">
            <hts-card>
                <h3>
                    Markup
                </h3>

                <div
                    v-loading="isLoading"
                    class="flex items-center">
                    <hts-form-input
                        v-model="globalSettingsInformation.markup"
                        :required="true"
                        readonly
                        :label="$t('labels.markup')">
                        <template #suffix>
                            %
                        </template>
                    </hts-form-input>
                    <span class="px-2 mt-6 cursor-pointer">
                        <hi-pencil-icon
                            class="w-5 h-5"
                            @click="openUpdateMarkup" />
                    </span>
                </div>

                <update-markup
                    ref="updateMarkup"
                    @update="handleUpdate" />
            </hts-card>

            <hts-card>
                <setting-cont-management @update="handleUpdate" />
            </hts-card>
        </div>
    </div>
</template>

<script lang="ts" setup>
import UpdateMarkup from './ignore/update-markup.vue'
import SettingContManagement from './ignore/setting-cont.vue'
const { $t } = useNuxtApp()
const store = $store()

const updateMarkup: any = ref(null)

const isLoading = ref(false)

const globalSettingsInformation = ref({ markup: 0 })

const emits = defineEmits(['updateData'])

const openUpdateMarkup = () => {
  if (updateMarkup.value) {
    updateMarkup.value.open()
  }
}

onMounted(() => {
  _initData()
})

const handleUpdate = () => {
  _initData()
}

const _initData = () => {
  isLoading.value = true

  globalSettingsInformation.value.markup = store.globalSettings.getGlobalSettings.markup

  isLoading.value = false
}
</script>
